import { createAction } from '../../../store.model';
import { SearchItem, SearchParams } from '../../core';
import { ActionType } from '../landing.action';
import { GridDays } from '../model/grid-days.model';
import { GridType } from '../model/grid-type.model';
import { TeamAlt } from '../model/team-alt.model';

export interface ChangeDateRange {
    type: GridType;
    days: GridDays;
    params: SearchParams;

    /** when grid === team */
    teamAlt?: TeamAlt;
}

export const changeDateRange = createAction<ActionType, ChangeDateRange>(
    ActionType.EVAL_LANDING__CHANGE_DATE_RANGE,
);

export interface ChangeDateRangeResult extends ChangeDateRange {
    result?: SearchItem[];
}

export const changeDateRangeResult = createAction<
    ActionType,
    ChangeDateRangeResult
>(ActionType.EVAL_LANDING__CHANGE_DATE_RANGE_RESULT);
